import React, {memo} from "react";
import {Link} from "@montana/shared/link";
import {useDynamicSettings} from "@montana/containers/dynamic-settings";
import {useTranslations} from "@montana/containers/translations";
import {IGlobalLinks} from "@montana/models/generated/cms.interface";

export const GuaranteeLink = memo(() => {
    const {links} = useDynamicSettings();
    const {guaranteePage} = links as IGlobalLinks;
    const translate = useTranslations();

    if (!guaranteePage) {
        return null;
    }

    return (
        <div className="guarantee-link">
            <Link to={guaranteePage} withStroke={true} strokeActive={false}
                  inverseStrokeAnimation={true}>{translate(t => t.general.guaranteeTextLink)}</Link>
        </div>
    );
});
